var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpgradeSkill(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 29,
    viewBox: "0 0 32 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.55
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.0408 28.1121H22.4453V0.176758H31.0408V28.1121ZM24.5942 25.9633H28.8919V2.32563H24.5942V25.9633Z",
    fill: "#001833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.2908 28.1114H11.6953V8.77148H20.2908V28.1114ZM13.8442 25.9625H18.1419V10.9204H13.8442V25.9625Z",
    fill: "#001833"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.54862 28.1122H0.953125V15.219H9.54862V28.1122ZM3.102 25.9634H7.39975V17.3679H3.102V25.9634Z",
    fill: "#001833"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpgradeSkill);
export default __webpack_public_path__ + "static/media/upgradeSkill.5c7e4a0c05a51f92ab29f352d49ca0e3.svg";
export { ForwardRef as ReactComponent };